<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <f7-block>
    <p>Permite seleccionar una fecha</p>
    <f7-row>
      <f7-col>
        <p class="display-flex justify-content-center">
          Plantilla 1:
        </p>
        <UCTimePicker
          template="P1"
        />
      </f7-col>
    </f7-row>
    <f7-row>
      <f7-col
        class="display-flex flex-direction-column align-items-center justify-content-center"
        width="100"
      >
        <p class="display-flex justify-content-center">
          Plantilla 2:
        </p>
        <UCTimePicker
          template="P2"
        />
      </f7-col>
    </f7-row>
  </f7-block>
</template>

<script>
import UCTimePicker from '@/components/common/UCTimePicker.vue';

export default {
  name: 'TestUCTimePicker',
  components: {
    UCTimePicker,
  },
};
</script>
